import { Pagination } from '@/constants/pagination';
import { PaginationAPI } from '@/types/pagination';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type TransactionState = {
  data: TransactionType[];
  pagination: PaginationAPI;
  totalElements?: number;
  loading: boolean;
  filters: TransactionFilterState;
  dataStatusTransaction: TransactionStatusType[];
  dataMethodTransaction: TransactionStatusType[];
  exportHistory: ExportHistoryItem[];
  exportHistoryPagination: PaginationAPI;
  transactionReport?: TransactionReportContent;
};

export const transactionInitialState: TransactionState = {
  data: [],
  pagination: {
    Page: Pagination.Page,
    totalPages: 0,
    totalElements: 0,
    Size: Pagination.Size,
  },
  loading: false,
  filters: {},
  dataStatusTransaction: [],
  dataMethodTransaction: [],
  exportHistory: [],
  exportHistoryPagination: {
    Page: Pagination.Page,
    totalPages: 0,
    totalElements: 0,
    Size: Pagination.Size,
  },
  transactionReport: undefined,
};

const slice = createSlice({
  name: 'transaction',
  initialState: transactionInitialState,
  reducers: {
    setListTransactionAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: TransactionType[];
        pagination?: PaginationAPI;
        totalElements?: number;
        append?: boolean;
      }>,
    ) {
      if (payload.append) {
        state.data = [...state.data, ...payload.data];
      } else {
        state.data = payload.data;
      }

      state.pagination = payload.pagination || state.pagination;
      state.totalElements = payload.pagination?.totalElements;
    },

    setTransactionLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    setTransactionStatusAction(
      state,
      action: PayloadAction<{
        dataStatusTransaction: TransactionStatusType[];
      }>,
    ) {
      const { payload } = action;
      state.dataStatusTransaction = payload.dataStatusTransaction;
    },
    setTransactionMethodAction(
      state,
      action: PayloadAction<{
        dataMethodTransaction: TransactionMethodType[];
      }>,
    ) {
      const { payload } = action;
      state.dataMethodTransaction = payload.dataMethodTransaction;
    },

    setTransactionFiltersAction(state, action: PayloadAction<TransactionFilterState>) {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetTransactionFiltersAction(state) {
      state.filters = {};
    },

    setExportHistoryAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: ExportHistoryItem[];
        pagination?: PaginationAPI;
        append?: boolean;
      }>,
    ) {
      if (payload.append) {
        state.exportHistory = [...state.exportHistory, ...payload.data];
      } else {
        state.exportHistory = payload.data;
      }

      state.exportHistoryPagination = payload.pagination || state.exportHistoryPagination;
    },

    setTransactionReportAction(
      state,
      action: PayloadAction<{
        dataTransactionReport: TransactionReportContent;
      }>,
    ) {
      const { payload } = action;
      state.transactionReport = payload.dataTransactionReport;
    },
  },
});

export const {
  setListTransactionAction,
  setTransactionLoading,
  setTransactionFiltersAction,
  resetTransactionFiltersAction,
  setTransactionStatusAction,
  setTransactionMethodAction,
  setExportHistoryAction,
  setTransactionReportAction,
} = slice.actions;
export default slice.reducer;
